import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, WIZ_PHYSIC_POSITION } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizBaseCollector,
  WizBasePopUp,
  WizCheckbox,
  WizDatasource,
  WizList,
  WizPopUp,
  WizVgroup,
  WizDropItemEvent,
  WizEventManager, WizEvent, WizTranslationManager,
  PopUpManager
} from '@wizeoo/akm-component-lib';
import { FIELD_KIND, EM_ACTION } from '@wizeoo/akm-compute-lib';
import { cloneDeep } from 'lodash-es';
import { WidgetConfigurationObj, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';

import { FreedataArgsVO } from  '../../../../vo/core/freedataargs.vo';
import { FreedataEditItemRenderer } from '../../freedatas/pops/freedata-edit-item.renderer';
import { ALK_EVENT_TYPE, WIDGET_KIND } from '../../../../model/enums';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { gridsterItemEvent } from '../../form/generic/form-widget.gridster.component';
import { ViewData } from '../../../../model/view.data';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { IFreedataWidget } from '../../../../manager/widgets/i-widget';
import { Model } from '../../../../model/model';
import { FreeDataVO } from '../../../../vo/core/freedata.vo';
import { FreedataValueVO } from '../../../../vo/core/freedatavalue.vo';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { FreedataHeaderEditPop } from '../../freedatas/pops/freedata-header-edit.pop';
import { widgetHeaderVO } from '../../pivot/renderers/header/header-editext.pop';



@Component({
  // popUp d'édition du grid en mode flat : gestion des emplacements de champs et rendu
  selector: 'freedata-tile-settings-pop',
  templateUrl: './freedata-tile-settings.pop.html',
})
export class FreedataTileSettingsPop extends WizBasePopUp {
  
  constructor(public elementRef: ElementRef, private _cdRef: ChangeDetectorRef) {
    super();
  }
  // liste des champs et mesures disponibles
  @ViewChild('freeList', { read: WizList }) freeList: WizList;
  /** le composant de filtre principal */
  @ViewChild('mainFilter', { read: FilterComponent })
  mainFilter: FilterComponent;
  // zone globale des listes
  @ViewChild('vgDetailZone', { read: WizVgroup, static: false })
  vgDetailZone: WizVgroup;

  @ViewChild('lstFilter', { read: WizList }) lstFilter: WizList; // liste des champs de filtre

  @ViewChild('cbShowDeleteCol', { read: WizCheckbox })  cbShowDeleteCol: WizCheckbox; // cb d'affichage de la colonne delete
  @ViewChild('cbShowSelectCol', { read: WizCheckbox })  cbShowSelectCol: WizCheckbox; // cb d'affichage de la colonne select
  @ViewChild('cbSelectUnique', { read: WizCheckbox }) cbSelectUnique: WizCheckbox; // cb sélection unique

  // dimensions demandées
  public static width: string = '1000px';
  public static height: string = 'calc(100% - 81px)';

  /** Renderer de la liste */
  public renderer: any = FreedataEditItemRenderer;

  public dataSource: WizDatasource<PivotField> = null; // DS des champs disponibles (au step)
  public filterDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();

  protected context: WidgetConfigurationObj; // la configuration
  protected updateCallback: Function; // la callback pour retour et traitement dans le pivotComponent
  
  public get widget(): IFreedataWidget {
    return this.datas;
  }

  public get model(): Model {
    return this.widget.model;
  }

  protected doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)
  protected fieldPop: WizPopUp; // la popUp d'édition des champs
  public popUpMode: WIDGET_KIND = WIDGET_KIND.GRID; // le mode de cette pop, pour alimenter les PKD

  // Le freeData fake utilisé juste pour la configuration
  fakeFreeDataValue: FreedataValueVO;

  /** autoriser la zone de drop de filtres et la col de sélection */
  public get useGridFunctions(): boolean {
    return this.widget?.widgetKind === WIDGET_KIND.FD_GRID || this.widget?.widgetKind === WIDGET_KIND.FD_TILE;
  }


  show(): void {

    this.context = cloneDeep(this.widget.context); 
    this.updateCallback = this.widget.backFromSettingsPop.bind(this.widget);


    const fd: FreeDataVO = this.model.freedataEngine.getFreeData(this.context.fdk.split(ViewData.CONTEXT_SEPARATOR)[0]);// todo gérer le level
    this.fakeFreeDataValue = this.model.freedataEngine.createFreeDataValue(fd, null);

    const filter = []; // alimentation du filtre de la DS principale

    this.mainFilter.configure(['code', 'labelOrDefaultLabel'], null, Array.from(filter)).build();

    const parts: string[] = this.context.fdk.split(ViewData.CONTEXT_SEPARATOR); // on split sur #
    const args: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(parts[0]);
    const fieldsMap: Map<string, FreedataArgsVO> = new Map(args.map(item => [item.code, item]));

    const dataDS: PivotField[] = [];
    args.forEach((fda: FreedataArgsVO) => {
      const wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(this.context.fdk, 0);
      wcio.fdvf = fda.code;
      dataDS.push(new PivotField(this.widget, wcio, null, fda));
    });


    // ajout du fake pour mettre un texte libre
    let wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_HTML;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.content.$');
    const fakeLabel: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeLabel.order = -3;
    dataDS.push(fakeLabel);

    // ajout du fake pour mettre une image
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_IMAGE;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.image.$');
    const fakeImg: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeImg.order = -2;
    dataDS.push(fakeImg);

    // ajout du fake pour mettre un bouton connect
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.fdvf = ViewData.FORM_ACTION;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.action.$');
    const fakeAction: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeAction.order = -1;
    dataDS.push(fakeAction);

    // ajout du fake pour mettre un filtre générique
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.cod = ViewData.FILTER_GENERIC;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.filter.$');
    const fakeFilter: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeFilter.order = -1;
    dataDS.push(fakeFilter);

    // ajout du fake pour mettre un filtre me
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.cod = ViewData.FILTER_ME;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.filter.me.$');
    const fakeMeFilter: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeMeFilter.order = -1;
    dataDS.push(fakeMeFilter);

    this.dataSource = new WizDatasource<PivotField>(dataDS)
    .setItemCodeField('code')
    .setSelectionMode('none')
    .setSortFields([{ property: 'order', way: 'asc', numeric: true },{ property: 'labelOrDefaultLabel', way: 'asc', numeric: false }]) //  
    .setFilter(this.filterFunc.bind(this))
    .build();

    // alimentation des collections depuis le contexte
    const preFilterArr: PivotField[] = [];

    this.buildWidgets();
    
    this.context.f.forEach((confItem: WidgetConfigurationItemObj) => {
      let fake = null;
      if(confItem.cod === ViewData.FILTER_GENERIC) {
          const ff: PivotField = new PivotField(this.widget, confItem, null, null);
          preFilterArr.push(ff);
      } else if(confItem.cod === ViewData.FILTER_ME) {
          const ff: PivotField = new PivotField(this.widget, confItem, null, null);
          preFilterArr.push(ff);
      } else {
        fake = this.dataSource.getItemByKey(confItem.fdvf);
          if (!!fake)  {
          const ff: PivotField = new PivotField(this.widget, confItem, null, fake.arg);
          ff.usedAsFilter = true;
          preFilterArr.push(ff);
        }
      }
      

    });

    this.filterDS.setSource(preFilterArr);

    this.feedDatasources();
    this.addListeners();
  }

  private buildWidgets(): void {
    
    const parts: string[] = this.context.fdk.split(ViewData.CONTEXT_SEPARATOR); // on split sur #
    const args: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(parts[0]);
    const fieldsMap: Map<string, FreedataArgsVO> = new Map(args.map(item => [item.code, item]));
    
    this.widgets = [];
    if (this.context.ff) {
      this.context.ff.forEach((obj: WidgetConfigurationItemObj) => {
        // console.log('ffsetting', obj, obj.subField);
        const matrix: FreedataArgsVO = fieldsMap.get(obj.fdvf); // va servir de matrice, c'est la structure
    
        if (!!matrix) {
          // mais on peut en faire plusieurs
          const result: GridsterWidgetItem = new GridsterWidgetItem(obj, new PivotField(this.widget, obj, null, matrix));
          
          this.widgets.push(result);
        } else if(ViewData.isFreeField(obj.fdvf)) {
          const result: GridsterWidgetItem = new GridsterWidgetItem(obj, new PivotField(this.widget, obj, null, null));
          
          this.widgets.push(result);
        }
      });      
    } 
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    this.lstFilter.wizDataProvider = this.filterDS;
    // unicité de champs sur les filtres
    this.lstFilter.dropControlFunction = this.FilterDropControl.bind(this);

    // pas de filtre générique dans le contenu
    // TODO TODO this.tile.dropControlFunction


    // ajout du transformer sur les zones cibles
    this.lstFilter.dropTransformFunction = this.fakeToFF.bind(this);

    this.cbShowDeleteCol.wizChecked = !!this.context.shd;
    this.cbShowSelectCol.wizChecked = !!this.context.shs;
    this.cbSelectUnique.wizChecked = !!this.context.shsu;
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.mainFilter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre de la DS principale
    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD, this.showConfPop); // demande de conf d'un champ
  }

  /** icone de suppression globale */
  public onDeleteClick(): void {
    this.widgets = [];
  }


  /** validation du contenu */
  public doValid(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  widgets: GridsterWidgetItem[] = [];

  /** modification du context pour retour sur la base des params */
  private updateContext(): void {
    
    // mémorisation du contexte de filtre
    const filterMap: Map<string, WidgetConfigurationItemObj> = new Map<string, WidgetConfigurationItemObj>();
    if (this.context.f) {
      this.context.f.forEach((wcio: WidgetConfigurationItemObj) => {
        if(wcio.cod === ViewData.FILTER_GENERIC) {
          filterMap.set(wcio.cod, wcio);
        } else if(wcio.cod === ViewData.FILTER_ME) {
          filterMap.set(wcio.cod, wcio);
        }
         else {
          filterMap.set(wcio.fdvf, wcio);
        }
  
      });
    }
    
    this.context.r = [];
    this.context.f = [];
    
    let idx: number = 1; // positions
    let confItem: WidgetConfigurationItemObj;
    this.filterDS.getSource().forEach((item: PivotField) => { // filters
      confItem = this.model.widgetEngine.newWcio(this.context.fdk, idx);
      if(item.isFreeFilter) {
        confItem.cod = item.code;
      } else {
        confItem.fdvf = item.code;
      }
      
      confItem.lbl = item.label;
      confItem.filtHide = item.filtHide;
      this.model.widgetEngine.wcioColParams(confItem, false, item.colMinSize, item.colSize); // taille de col
      this.model.widgetEngine.wcioStyleParams(confItem, item.format, item.style); // format & style
      
      let realFilterCode: string = null;
      if(confItem.cod === ViewData.FILTER_GENERIC) {
        realFilterCode = ViewData.FILTER_GENERIC;
      } else if(confItem.cod === ViewData.FILTER_ME) {
        realFilterCode = ViewData.FILTER_ME;
      } else {
        realFilterCode = confItem.fdvf;
      }

      if (filterMap.has(realFilterCode)) { // reprise des filtres existants
        confItem.sel = filterMap.get(realFilterCode).sel;
        confItem.filtExp = filterMap.get(realFilterCode).filtExp;
      }
      this.context.f.push(confItem);
      idx++;
    });


    this.context.ff = this.widgets.map((obj) => obj.source);

    this.context.shd = this.cbShowDeleteCol.wizChecked; // affichage du delete
    this.context.shs = this.cbShowSelectCol.wizChecked; // affichage du select
    this.context.shsu = this.cbSelectUnique.wizChecked; // affichage du select unique
  }

  public onHide() {
    
    WizEventManager.removeListener(this, this.mainFilter, WIZ_EVENT_TYPE.FILTER); // ecouteur sur le filtre de la DS principale
    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD); // demande de conf d'un champ

    if (this.doSaveFlag) {
      if (!!this.updateCallback) {
        this.updateContext();
        this.updateCallback(this.context);
      }
    }
  }

  /* ##############################################################################
                    filtre et rendu de la DS principale
     ############################################################################## */

  /**
   * modification du filtre
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.dataSource.refresh();
  }

  // filterFunc de la collection principale
  protected filterFunc(item: any): boolean {
    return this.mainFilter.checkVisible(item);
  }

  onWidgetsChanged(event: gridsterItemEvent) {
    // console.log('onWidgetsChanged',event, this.widgets);
    switch(event.action) {
      case EM_ACTION.CREATE:
        this.widgets = [event.item, ...this.widgets];
        break;
      case EM_ACTION.UPDATE:
        // console.log('onWidgetsChanged rien a faire');
        event.item.updateCoords(); // mise à jour des coords
        break;
      case EM_ACTION.DELETE:
        this.widgets.splice(this.widgets.indexOf(event.item), 1);
        break;     
    }
  }

  /** Fonction de controle du drop */
  public FilterDropControl({ item, dragSource }: WizDropItemEvent): boolean {
    const field: PivotField = item.data as PivotField;
    if (dragSource === this.lstFilter) {
      // déplacement self dans la liste de filtre
      return true; // on laisse passer
    }

    if(!!field.isFreeFilter) {
      for (const ff of this.filterDS.getSource()) {
        if (ff.code === field.code) {// une seule fois pour chaque filtre free
          return false;
        }
      }
      return true;
    }

    if (!field.arg || field.arg.dataType === FIELD_KIND.BINARY) { // pas les images
      return false;
    }

    // sinon, contrôle d'unicité du filtre
    for (const ff of this.filterDS.getSource()) {
      if (ff.code === field.code) {
        return false;
      }
    }
    return true;
  }

  /**
   * sur drop d'un FeiKeyDef, encapsulation en PivotField avant ajout à la DS
   * @param wbc la liste source
   * @param item l'objet draggé
   * @returns le pivotField
   */
  protected fakeToFF(wbc: WizBaseCollector, item: PivotField): PivotField {
    const wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(item.contextItem.cod, 0);
    const fake: FreedataArgsVO = item.arg;
    let result: PivotField = null;
    switch (wbc) {
      case this.lstFilter:
        result = new PivotField(this.widget, wcio, null, fake);
        // result.fdvField = item.fdvField;// prise du FDV, pour filtre générique
        //result.isFreeFilter = item.isFreeFilter; // filtre générique
        result.usedAsFilter = true;
        break;
    }
    return result;
  }

  /**
   * demande d'affichage de la popUp de configuration des champs
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
  protected showConfPop(e: AlkEvent): void {
    if (PopUpManager.exist(this.fieldPop)) {
      // suppression de l'instance existante
      this.fieldPop.hide();
    }

    // // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.fieldPop = new WizPopUp( FreedataHeaderEditPop, true, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      FreedataHeaderEditPop.baseWidth + 'px',
      FreedataHeaderEditPop.baseHeight + 'px');

    // construction des données
    const datas: widgetHeaderVO = {
      popReference: this.fieldPop,
      fei: null,
      context: this.context,
      updateCallback: this.backFromFieldPop.bind(this),
      pivotField: e.data[0],
      baseCollector: e.data[1],
      popUpMode: this.popUpMode,
      widget: this.widget
    }

    // // alimentation des datas
    this.fieldPop.datas = datas;

    this.fieldPop.show();
  }

  /**
   * retour d'édition de champ
   * @param wbc la collection d'origine, transmise par l'event de showConfPop
   * @param pf PivotField
   */
  protected backFromFieldPop(wbc: WizBaseCollector, pf: PivotField): void {
    wbc.wizDataProvider.refresh();
  }



}
